import clsx from "clsx";
import styles from "./SectionCard.module.scss";

interface Props {
  id: string;
  ariaLabelledby: string;
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard(props: Props) {
  return (
    <section
      className={clsx(styles.section, props.className)}
      id={props.id}
      aria-labelledby={props.ariaLabelledby}
    >
      <h2 id={props.ariaLabelledby}>{props.title}</h2>
      <p>{props.description}</p>

      {props.children}
    </section>
  );
}
